import Joi from 'joi';
import type { IMessageShape } from '../dialogue';
import { messageSchema } from '../dialogue';
import type { SchemaOf } from '../helpers';
import { objectSchemaOf } from '../helpers';

export type VocaliseType = 'message' | 'announcement';

export const vocaliseTypeSchema = Joi.string().valid('message', 'announcement');

export interface IVocalise {
  message: IMessageShape;
  conversationId: string;
  timestamp?: number;
  type?: VocaliseType;
}

export const vocaliseSchemaMap: SchemaOf<IVocalise> = {
  message: messageSchema.required(),
  conversationId: Joi.string().required(),
  timestamp: Joi.number().optional(),
  type: vocaliseTypeSchema.optional(),
};

export const vocaliseSchema = objectSchemaOf<IVocalise>(vocaliseSchemaMap);
